
import { IRestfulConfigMap } from "@core/data-access/restful";
import { envConfig } from "@env/env-config";
/**
 * @description 
 * API接口文档:
 * 分类:mockup-apis
 * 
 */
let ImageMockupRestServiceConfig: IRestfulConfigMap = {
    "imageMockupRestService": {
        appPath: envConfig.appPath("base"),
        isAuth: true,
        actions: {
            // 获取产品图片模型
            getAll: {
                method: "get",
                path: "api/:type/:id/mockupImages",
                testPath: "api/:type/:id/mockupImages",
                paramDefaults: {
                    type:"@type",
                    id: "@id",
                    versionedAttributeId:"@versionedAttributeId"
                }
            },
            // 查看单个Mockup图生成信息
            getOne: {
                method: "get",
                path: "api/mockupImages/:id/status",
                testPath: "api/mockupImages/:id/status",
                paramDefaults: {
                    id: "@id"
                }
            },
            // 下载Mockup图片
            download: {
                method: "get",
                path: "file/:fileName",
                testPath: "file/:fileName",
                paramDefaults: {
                    fileName: "@fileName"
                }
            },
            // 重新生成mockup图片（同步)
            retry:{
                method: "put",
                path: "api/mockupImages/:imageId/retry",
                testPath: "api/mockupImages/:imageId/retry",
                paramDefaults: {
                    imageId:"@imageId",
                    async: "@async"
                } 
            }
        }
    }
}

export { ImageMockupRestServiceConfig };